import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getDocumentation,
  documentationSendEmail,
  getUserManual,
} from "../../Dokumentacija/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    documentation: state.documentationReducer.documentation,
    uploadingType: state.documentationReducer.loading,
    userManual: state.documentationReducer.userManual,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getDocumentation,
      documentationSendEmail,
      getUserManual,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
